export const API_ROUTES = {
  AUTHOR_AUTH_REQUEST_SMS: '/api/v1/author_auth-request-sms',
  AUTHOR_AUTH_CHECK_SMS_CODE: '/api/v1/author_auth-check-sms-code',

  AUTHOR_REGISTER: '/api/v1/author_register',
  AUTHOR_GET: '/api/v1/author_get-auth',

  DICTIONARY_AGREEMENT_TYPES: '/api/v1/agreement-types_get-list',
  DICTIONARY_PRODUCT_TYPES: '/api/v1/product-types_get-list',
  DICTIONARY_LEGAL_ENTITIES: '/api/v1/legal-entities_get-list',
  DICTIONARY_PRODUCTS: '/api/v1/products_get-list',
  DICTIONARY_PUBLICATION_GROUPS: '/api/v1/publication-groups_get-list',

  AGREEMENT_GET: '/api/v1/agreement_get-by-id',
  AGREEMENT_ADMIN_GET: '/api/admin/v1/agreement_get-by-id',
  AGREEMENTS: '/api/admin/v1/agreement_search',
  AGREEMENT_CREATE: '/api/admin/v1/agreement_create',
  AGREEMENT_UPDATE: '/api/admin/v1/agreement_update',
  AGREEMENT_DELETE: '/api/admin/v1/agreement_delete',
  AGREEMENT_PREVIEW: '/api/admin/v1/agreement_get-html-preview',
  AGREEMENT_DOWNLOAD: '/api/v1/agreement_download',
  AGREEMENT_SIGN: '/api/v1/agreement_sign',

  SIGNED_AGREEMENTS: '/api/v1/agreement_get-signed-list',
  UNSIGNED_AGREEMENTS: '/api/v1/agreement_get-not-signed-list',

  USER_UPDATE: '/api/v1/author_update',
  ADMIN_USER_UPDATE: '/api/admin/v1/author_update',

  AUTHORS: '/api/admin/v1/author_search',
  AUTHORS_CHECK: '/api/admin/v1/author_exists-by-phone',
  AUTHOR_DELETE: '/api/admin/v1/author_delete',

  PRODUCTS: '/api/admin/v1/product_search',
  PRODUCT_CREATE: '/api/admin/v1/product_create',
  PRODUCT_UPDATE: '/api/admin/v1/product_update',
  PRODUCT_GET: '/api/admin/v1/product_get-by-id',
}
